module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module chunks = 2